import styled, { css } from 'styled-components'

import {
  backgroundColor,
  complementaryColor,
  darkGrayColor,
  primaryColor,
  saleAlternativeColor,
} from 'uiComponents/constants/colors'
import {
  fontFamilyPrimary,
  fsXXXS,
  fwBold,
} from 'uiComponents/constants/typography'

const NumberBadge = styled.span<{
  type?: 'disabled' | 'default' | 'highlight' | 'highlight-disabled'
}>`
  height: 20px;
  line-height: 20px;
  border-radius: 999px;
  padding: 0 10px;
  display: inline-block;
  font-size: ${fsXXXS}px;
  text-align: center;
  ${fwBold};
  ${fontFamilyPrimary};

  ${({ type }) => {
    switch (type) {
      case 'highlight':
        return css`
          color: ${complementaryColor};
          background-color: ${saleAlternativeColor};
          border: 1px solid transparent;
        `
      case 'disabled':
        return css`
          color: ${darkGrayColor};
          background-color: ${backgroundColor};
          border: 1px solid transparent;
        `
      case 'highlight-disabled':
        return css`
          color: ${saleAlternativeColor};
          border: 1px solid ${saleAlternativeColor};
          background-color: ${complementaryColor};
        `
      case 'default':
      default:
        return css`
          background-color: ${primaryColor};
          color: ${complementaryColor};
          border: 1px solid transparent;
        `
    }
  }};
`

export default NumberBadge
